<h1>Dashboard</h1>
<div class="dashboard-container">
  <div class="dashboard-row">
    <app-tasks-summary class="dashboard-item"></app-tasks-summary>
  </div>
  <div class="dashboard-row">
    <app-tickets-summary class="dashboard-item"></app-tickets-summary>
  </div>
  <div class="dashboard-row">
    <app-communications-summary class="dashboard-item"></app-communications-summary>
  </div>
</div>
